const dev = "http://localhost:5010";
const production = "https://gtf-khaled.com";
const isDev = false;
export const mainUrl = isDev ? dev : production;
const urls = {
  createNewUser: `${mainUrl}/api/users/createNewAccount`,
  createNewFacultyAccount: `${mainUrl}/api/users/createNewFacultyAccount`,
  checkEmailExistance: `${mainUrl}/api/users/checkEmailExistance`,
  getUsers: (faculty_id) => `${mainUrl}/api/users/getUsers/${faculty_id}`,
  checkfacultyName: `${mainUrl}/api/users/checkfacultyName`,
  deleteUser: (uuid) => `${mainUrl}/api/users/delete/${uuid}`,
  changePswd: `${mainUrl}/api/users/changepswd`,
  getStore: (faculty_id) => `${mainUrl}/api/store/getStore/${faculty_id}`,
  saveNewItemsNames: `${mainUrl}/api/store/saveNewItemsNames`,
  placeNewOrder: `${mainUrl}/api/store/placeNewOrder`,
  getStoreItems: `${mainUrl}/api/store/getStoreItems`,
  addNewItemsToStore: `${mainUrl}/api/store/addNewItemsToStore`,
  deleteItemFromStore: `${mainUrl}/api/store/deleteItemFromStore`,
  confirmOrder: `${mainUrl}/api/store/confirmOrder`,
  getOrders: (uuid) => `${mainUrl}/api/store/getOrders/${uuid}`,
  getApprovedOrders: `${mainUrl}/api/store/getApprovedOrders`,
  fullFillOrder: `${mainUrl}/api/store/fullFillOrder`,
  getAllOrders: (faculty_id) =>
    `${mainUrl}/api/store/getAllOrders/${faculty_id}`,

  deleteOrder: (applicationType, orderId) =>
    `${mainUrl}/api/store/deleteOrder/${applicationType}/${orderId}`,
  updateOrder: `${mainUrl}/api/store/updateOrder`,
  // inventroy
  addNewInventory: `${mainUrl}/api/inventory/addNew`,
  getInventory: `${mainUrl}/api/inventory/getAll`,
  getInventoryNames: `${mainUrl}/api/inventory/getInventoryNames`,
  checkInventoryCode: `${mainUrl}/api/inventory/checkInventoryCode`,
  deleteItemFromInventory: `${mainUrl}/api/inventory/delete`,
  removeItemFromStock: `${mainUrl}/api/inventory/removeItemFromStock`,
  addNewNames: `${mainUrl}/api/inventory/addNewNames`,
  addInventoryUsage: `${mainUrl}/api/inventory/addInventoryUsage`,
  getUsePlaces: `${mainUrl}/api/inventory/getUsePlaces`,
  getUsedPlacesData: `${mainUrl}/api/inventory/getUsedPlacesData`,
  getBeneficiaries: `${mainUrl}/api/inventory/getBeneficiaries`,
  deleteInventoryUsage: `${mainUrl}/api/inventory/deleteInventoryUsage`,
  uploads: (p) => `${mainUrl}/api/uploads/${p}`,
  // service
  requestService: `${mainUrl}/api/services/requestService`,
  getRequestedServices: (uuid) =>
    `${mainUrl}/api/services/getRequestedServices/${uuid}`,
  deleteService: (serviceId) =>
    `${mainUrl}/api/services/deleteService/${serviceId}`,
  getAllServices: `${mainUrl}/api/services/getAllServices`,
  getApprovedServices: `${mainUrl}/api/services/getApprovedServices`,
  // invoice urls

  addNewSupplier: `${mainUrl}/api/invoice/addNewSupplier`,
  getSuppliers: `${mainUrl}/api/invoice/getSuppliers`,
  newInvoice: `${mainUrl}/api/invoice/newInvoice`,
  getAllInvoices: `${mainUrl}/api/invoice/getAllInvoices`,
  searchInvoices: `${mainUrl}/api/invoice/searchInvoices`,
  getInvoiceDetails: (invoice_id, faculty_id) =>
    `${mainUrl}/api/invoice/getInvoiceDetails/${faculty_id}/${invoice_id}`,

  //print
  printInvoiceDetails: (invoice_id, supplier_id) =>
    `${mainUrl}/api/print/invoice-details/${invoice_id}/${supplier_id}`,
  printInventoryQRCode: (token) =>
    `${mainUrl}/api/print/printInventoryQRCode?token=${token}`,
  printMultipleInvQrCode: `${mainUrl}/api/print/printMultipleInvQrCode`,
  printInventorySheet: `${mainUrl}/api/print/printInventorySheet`,
  // settings
  updateSettings: `${mainUrl}/api/settings/update`,
  newSettings: `${mainUrl}/api/settings/new`,
  getSettings: `${mainUrl}/api/settings/get`,
};
export default urls;
